import React from 'react';
const BUNDLE_IMAGE = 'https://cdn.magicpatterns.com/uploads/k5EXRi3d4TukixKqqWhAdx/Pack_de_tablets_con_prompts_de_IA.webp';

// Product mockup: main toolkit + the 4 bonuses.
export function BookStack() {
  return <img src={BUNDLE_IMAGE} alt="100+ AI Prompts toolkit bundle with the 4 free bonus guides" className="mx-auto h-auto w-full max-w-2xl" loading="eager" data-id="element-37" data-mp="23kiwqne7a4t9" />;
}